// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import VueResource from "vue-resource";
import Vuex from "vuex";
import store from "./store/index";
import host from "./host";
import global from "./global";
import BaiduMap from "vue-baidu-map";
import "./plugins/quill/index";

// import '../theme/index.css'

Vue.config.productionTip = false;
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: "ZbnsvsDDco2e9gHLAPcgeAiY4zFDhQng",
});

//toggle-button
import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);

import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(VueResource);
Vue.use(global);
Vue.http.options.emulateJSON = true;
window.host = host.host;
/* eslint-disable no-new */

import VueAMap from "vue-amap";
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "e787f35b1ec14296b058335427ea5284",
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geolocation",
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: "1.4.4",
});

let requestState = true;
Vue.http.interceptors.push((request, next) => {
  let token = localStorage.getItem("token");
  let authorization = localStorage.getItem("authorization");
  if (token) {
    request.headers.set("token", token);
  }
  if (authorization) {
    request.headers.set("authorization", authorization);
  }

  // if (
  //   !request.url.trim().startsWith("https://") &&
  //   !request.url.trim().startsWith("http://")
  // ) {
  //   if (request.url.startsWith("/")) {
  //     request.url = "http://www.smtrap.com" + request.url;
  //   } else {
  //     request.url = "http://www.smtrap.com/" + request.url;
  //   }
  // }
  if (request.url === "/main/editMenu") {
    request.headers.set("Content-Type", "application/json");
  }
  next((response) => {
    if (response.data.errorCode == "e01") {
      if (request.url == "common/evalWorkOrder") {
        //用户评价发生错误时
        return response;
      }
      if (requestState) {
        requestState = false;
        vm.$router.push("/login");
      } else {
        vm.$router.push("/login");
      }
      return response;
    } else {
      requestState = true;
      return response;
    }
  });
});
router.beforeEach((to, from, next) => {
  if (localStorage.getItem("token")) {
    next();
  } else {
    if (
      to.name === "auth" ||
      to.name === "loginJump" ||
      to.name === "OverviewInformationExport"
    ) {
      next();
    } else if (to.name !== "login") {
      next("/login");
    } else {
      next();
    }
  }
});
let vm = new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js